import { useState } from 'react';
import { CONFIG } from '../config';
import styles from './Terminal.module.css';

const TYPE_COLORS = {
  cmd: styles.tCmd,
  success: styles.tSuccess,
  info: styles.tInfo,
  warn: styles.tWarn,
  prompt: styles.tPrompt,
};

const TYPE_PREFIX = {
  cmd: <span className={styles.tPrompt}>⚔️ </span>,
  success: <span className={styles.tSuccess}>✓ </span>,
  info: <span className={styles.tInfo}>→ </span>,
  warn: <span className={styles.tWarn}>⚡ </span>,
  prompt: <span className={styles.tPrompt}>⚔️ </span>,
};

export default function Terminal() {
  const [key, setKey] = useState(0);

  return (
    <section className={styles.section} id="terminal">
      <div className={styles.grid}>
        {/* Left info */}
        <div className={styles.info}>
          <div className={styles.tag}>Live Feed</div>
          <h2 className={styles.title}>Agent Activity Log</h2>
          <p className={styles.desc}>
            Real-time execution stream from the BaseGladiator agent running autonomously across the Base network.
          </p>
          <div className={styles.statusList}>
            <div className={styles.statusItem}>
              <span className={`${styles.dot} ${styles.dotGreen}`} />
              <span>AGENT ONLINE</span>
            </div>
            <div className={styles.statusItem}>
              <span className={`${styles.dot} ${styles.dotBlue}`} />
              <span>BASE MAINNET CONNECTED</span>
            </div>
            <div className={styles.statusItem}>
              <span className={`${styles.dot} ${styles.dotGold}`} />
              <span>SCANNING ACTIVE</span>
            </div>
          </div>
        </div>

        {/* Terminal */}
        <div
          className={styles.terminal}
          onMouseEnter={() => setKey(k => k + 1)}
        >
          <div className={styles.bar}>
            <div className={styles.dot1} />
            <div className={styles.dot2} />
            <div className={styles.dot3} />
            <span className={styles.barTitle}>GLADIATOR_AGENT_v1.0 — BASE MAINNET</span>
          </div>
          <div className={styles.body} key={key}>
            {CONFIG.terminalLines.map((line, i) => (
              <div
                key={i}
                className={styles.line}
                style={{ animationDelay: `${i * 0.6 + 0.3}s` }}
              >
                {TYPE_PREFIX[line.type]}
                <span className={TYPE_COLORS[line.type] || styles.tData}>
                  {line.text}
                  {line.cursor && <span className={styles.cursor} />}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
